import React from "react";

const SingleCard = () => {
  return <div>SingleCard</div>;
};

export default SingleCard;
